import { SelectedOptionType } from '@components/MobileMultiSelect/types';
import { SelectPickerOptionProps } from '@components/SelectPicker/types';

import styles from './AutoComplete.module.scss';
import { AutoCompleteInputVariantType, wrapperType } from './types';

export const getInputVariantClass = (
    inputVariant: wrapperType = 'borderless',
    variant: AutoCompleteInputVariantType = 'default',
): string => {
    return styles[`${inputVariant}-autocomplete--${variant}`];
};

export const handleFinalSearchOptions = (
    optionsToDisplay: SelectedOptionType[],
    transformedOptions: SelectedOptionType[],
): SelectedOptionType[] | [] => {
    const selectedOptionsMap = new Map(transformedOptions.map((obj) => [obj?.value, obj]));
    const finalOptions: SelectedOptionType[] = [];

    transformedOptions?.forEach((option) => {
        finalOptions.push(option);
    });

    optionsToDisplay?.forEach((option) => {
        if (!selectedOptionsMap.has(option.value)) {
            finalOptions.push(option);
        }
    });

    return finalOptions;
};

export const resetPickerOptions = (
    options: SelectPickerOptionProps[],
): SelectPickerOptionProps[] => {
    const result: SelectPickerOptionProps[] = [];

    options.forEach((option) => {
        result.push(option);
    });

    return result;
};
